import { InjectionToken, Signal } from '@angular/core';

/**
 * What an `sh-field` tells the control inside it. A control injects this
 * (optionally) and so needs no wiring from the page:
 * - `controlId`: the `id` for the native element, matching the label's `for`;
 * - `readonly`: the field is read-only, so the control renders its lock;
 * - `error`: there is an error message, so the control shows its invalid look.
 */
export interface ShFieldContext {
  readonly controlId: string;
  readonly readonly: Signal<boolean>;
  readonly error: Signal<string | null | undefined>;
}

export const SH_FIELD = new InjectionToken<ShFieldContext>('SH_FIELD');
